module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lBCnh"))).then(() => parcelRequire('3a9aZ'));